import apiHeader from '@/helpers/apiHeader';

const orderTypeService = {
  list(page, params) {
    return apiHeader.get('order-types?page=' + page, { params }); // Ambil daftar order types dengan pagination
  },
  get(id) {
    return apiHeader.get('order-types/' + id);
  },
};

export default orderTypeService;
